import React from 'react';
import PropTypes from 'prop-types';
import { formatDate, formatPrice, isOurOffer } from './common.js';
import uiLocale from '../../../utils/UILocale.js';

export default function TableRow(props) {
  const {
    competitorId, competitorName, lastChecked, price, deliveryMessage = '', showDelivery
  } = props;
  const LAST_CHECKED_TEXT = uiLocale.getString('component.price-promise.last-checked');

  return (
    <tr className={isOurOffer(competitorId) ? 'our-offer' : ''}>
      <td dangerouslySetInnerHTML={{ __html: competitorName }} />
      <td>
        <ul className={'flat-list'}>
          <li className={'price'}>{ formatPrice(price) }</li>
          <li className={'last-checked'}>
            { `${LAST_CHECKED_TEXT.toLowerCase()} ${formatDate(lastChecked)}` }
          </li>
        </ul>
      </td>
      { showDelivery && <td dangerouslySetInnerHTML={{ __html: deliveryMessage }} /> }
    </tr>
  );
}

TableRow.propTypes = {
  competitorId: PropTypes.number.isRequired,
  competitorName: PropTypes.string.isRequired,
  lastChecked: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  deliveryMessage: PropTypes.string,
  showDelivery: PropTypes.bool.isRequired
};

TableRow.defaultProps = {
  deliveryMessage: ''
};
